/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFTriggerUWResponse
 */
export interface CRSFTriggerUWResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFTriggerUWResponse
     */
    domains: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CRSFTriggerUWResponse
     */
    process_id: string;
}

/**
 * Check if a given object implements the CRSFTriggerUWResponse interface.
 */
export function instanceOfCRSFTriggerUWResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "domains" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function CRSFTriggerUWResponseFromJSON(json: any): CRSFTriggerUWResponse {
    return CRSFTriggerUWResponseFromJSONTyped(json, false);
}

export function CRSFTriggerUWResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFTriggerUWResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'domains': json['domains'],
        'process_id': json['process_id'],
    };
}

export function CRSFTriggerUWResponseToJSON(value?: CRSFTriggerUWResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'domains': value.domains,
        'process_id': value.process_id,
    };
}

